import React from "react";
import styled from "styled-components";

const FooterUI = styled.footer`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 60px;
  color: var(--white);
  font-family: var(--roboto);
  background-color: var(--black);
  font-size: 0.9rem;
  text-align: center;

  span {
    font-weight: 700;
    padding: 0px 5px;
    color: var(--red);
  }
`;

const Paragraph = styled.p`
  display: flex;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterUI>
      {" "}
      <Paragraph>
        &copy; Copyright 2022 <span>Real Cars</span> - Todos los derechos
        reservados{" "}
      </Paragraph>
    </FooterUI>
  );
};

export default Footer;
